<template>
  <b-modal
    ref="my-modal"
    scrollable
    centered
    hovered
    no-close-on-backdrop
    header-bg-variant="light"
    footer-bg-variant="light"
    size="sm"
    button-size="sm"
  >
    <template #modal-header="">
      <h5>EMPLOYEES REPORT</h5>
    </template>
    <!-- <form>
      <b-form-group label="Name" label-for="name-input">
        <b-form-input id="name-input" required></b-form-input>
      </b-form-group>
    </form> -->
    <template #modal-footer="{}">
      <div class="w-100">
        <b-button
          class="float-left"
          size="sm"
          variant="secondary"
          @click="goHome()"
        >
          go Back
        </b-button>
        <b-button
          class="float-right"
          size="sm"
          variant="success"
          @click="printReporte()"
        >
          Print
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import axios from "axios";

export default {
  name: "PrintEmployees",
  data: function () {
    return {
      url: "https://www.imandrades.com/php/",
    };
  },
  mounted() {
    this.$refs["my-modal"].show();
  },
  methods: {
    goHome() {
      this.$refs["my-modal"].hide();
      this.$router.push("menuDesktop");
    },
    printReporte: async function () {
      try {
        await axios.get(this.url + "rptEmpleados.php");
        window.open(this.url + "pdf/rptEmpleados.pdf", "_blank");
      } catch (error) {
        console.log("Error!!");
      }
    },
  },
};
</script>